/* eslint-disable */

import * as React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
import * as contentDispatch from 'redux/ducks/content';
import * as uiDispatch from 'redux/ducks/ui';
import * as ingredientDispatch from 'redux/ducks/data/ingredients';
import './index.scss';
// MATERIAL TABLE
import { Column, MTableBody } from 'material-table';
import AlteredMaterialTable from 'components/MaterialTable';

// ICONS
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddPhotoIcon from '@material-ui/icons/AddAPhoto';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';

// OVERWRITTEN MATERIAL TABLE COMPONENTS
import CustomTableBody from 'components/MaterialTable/components/customTableBody';
import CustomTableRow from 'components/MaterialTable/components/customTableRow';
import CustomTableHead from 'components/MaterialTable/components/customTableHead';
import CustomEditRow from 'components/MaterialTable/components/customEditRow';
import CustomTableAction from 'components/MaterialTable/components/customTableAction';

// MISC
import {
  colors,
  IconButton,
  MenuItem,
  Select,
  Slide,
  Switch,
  TextField,
  Tooltip,
  withWidth,
  FormControlLabel,
  Chip,
  TableRow,
  TableCell,
  FormControl,
  InputLabel,
  Checkbox,
  Box,
  ListItemIcon,
  ListItemText,
  Divider
} from '@material-ui/core';
import { WithWidth } from '@material-ui/core/withWidth';
import palette from 'styles/palette';
import ImageGallery from 'components/modalContent/image-gallery';
import Input from 'components/Input';
import NumberInput from 'components/Input/NumberInput';
import { formatMass, unformatMass } from 'components/FormattedMass';
import { formatMoney, formatWeight, unformat } from 'utils/number-format';
import { validate } from 'utils/validator';
import { showNotification } from 'redux/ducks/notification';
import * as registrationPointsDispatch from 'redux/ducks/data/registrationPoints';
import * as labelsDispatch from 'redux/ducks/data/labels';
import {
  getNonDeletedRegistrationPointsDepthFirst,
  Label,
  RegistrationPoint
} from 'redux/ducks/data/registrationPoints';
import * as settingsDispatch from 'redux/ducks/settings';
import HelpText from 'components/HelpText';
import { AREA, getAllowedLabels, getParentLabels, LABELS, Labels, PRODUCT } from 'utils/labels';
import { scrollToEl } from 'utils/helpers';
import { isIE11 } from 'utils/browsers';
import { NumberFormatValues } from 'react-number-format';
import HowToAccordion from 'pages/Settings/components/settings/registrations/HowToAccordion';
import ReasonsContainer from './components/reasonTable';
import SoundSelector from 'pages/Settings/components/soundSelector';
import LockIcon from '@material-ui/icons/Lock';
import LockedRegistrationDays from 'pages/Settings/components/settings/registrations/LockRegistrationDays';
import { IPatchObject } from 'redux/ducks/data/registrations';
import { CreateIngredient } from 'redux/ducks/data/ingredients';
import IngredientTable from 'pages/Settings/components/settings/registrations/components/ingredientTable/IngredientTable';
import moment from 'moment/moment';
import MaxRegistrationAmount from 'pages/Settings/components/settings/registrations/MaxRegistrationAmount';
import CreateNewLabelForm from 'pages/Settings/components/settings/registrations/components/createLabel';
import { CreateLabel } from 'redux/ducks/data/labels';
import LabelsContainer from 'pages/Settings/components/settings/registrations/components/labelTable';

// MT options (https://material-table.com/#/docs/all-props)
const registrationPointTableOptions: any = {
  actionsColumnIndex: -1,
  showTitle: true,
  search: false,
  searchFieldAlignment: 'left',
  emptyRowsWhenPaging: false,
  paginationType: 'stepped',
  toolbarButtonAlignment: 'right',
  headerStyle: {
    backgroundColor: colors.grey['50']
  },
  rowStyle: {
    //CRAS: IE11 has an issue with transitioning opacity on table rows
    transition: (isIE11 ? '' : 'opacity 300ms ease-out, ') + 'background-color 500ms ease-out',
    borderBottom: `1px solid ${colors.grey['200']}`,
    height: 55
  },
  pageSize: 25,
  pageSizeOptions: [10, 15, 20, 25],
  actionsCellStyle: {
    whiteSpace: 'pre'
  }
};

export const columnWidthMap = {
  default: {
    width: '150px',
    minWidth: '150px',
    maxWidth: '150px'
  },
  small: {
    width: '125px',
    minWidth: '125px',
    maxWidth: '125px'
  },
  large: {
    width: '160px',
    minWidth: '160px',
    maxWidth: '160px'
  }
};

// MT options (https://material-table.com/#/docs/all-props)
type CreateResult = {
  payload: RegistrationPoint;
};

type DeleteResult = {
  payload: string;
};

interface OwnProps {
  contentType: string;
}

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface ComponentProps
  extends OwnProps, StoreProps, DispatchProps, WrappedComponentProps, WithWidth {}

const NO_ID = 'no-id';
const NEW_OR_UPDATED_ROW = 'new-or-updated-row';
const deleteTransitionDuration = 1000;
// todo: should be iso dows 1-7
const DAYS_OF_WEEK = [1, 2, 3, 4, 5, 6, 0];

class RegistrationSettings extends React.Component<ComponentProps, {}> {
  deletedRow: any;
  tableRef = React.createRef<any>();

  // customActions: Custom actions to be added besides the default ones 'Edit' & 'Delete', on each table row
  private customActions: {
    onClick: (event, rowData) => void;
    icon: () => any;
    tooltip: string;
  }[];
  // parentId: Used to know under which element we need to render an Edit row, and we also pass it to the endpoint
  private parentId: number;
  // expandedTrees: Used to keep track of which rows are expanded, so that when MT re-renders and collapses all trees, we can re-expand them
  private expandedTrees: number[];
  // whitelistedKeys: Array including properties that we want to work with. Taken from old solution.
  private whitelistedKeys: string[];
  // newRow: Variable which we can use to determine if the row we're rendering is a newly added one. (Styling purposes)
  private newRow: number | string;
  // updatedRow: Just like newRow, this is used to determine if the row we're rendering has just been updated. (Styling purposes)
  private updatedRow: number | string;
  // path: Used in the CustomEditRow to calculate indentation, depending on how many levels in we are
  private path: string;
  // parentLabel: Used to figure out the possible labels a new or existing registration point can have
  private parentLabel: Labels;

  constructor(props: ComponentProps) {
    super(props);

    // Custom actions to be added besides the default ones Edit & Delete
    this.customActions = [
      {
        icon: () => <AddIcon color={props.hasRegistrationPointsLocked ? 'disabled' : 'primary'} />,
        tooltip: props.intl.formatMessage(
          { id: 'settings.content.add' },
          { contentType: props.intl.formatMessage({ id: props.contentType }) }
        ),
        onClick: (event, rowData) => {
          this.tableRef.current.onEditingCanceled('update');
          this.hideAddNewRow();
          this.parentId = rowData.id;
          this.parentLabel = rowData.label;

          if (!rowData.tableData.isTreeExpanded) {
            this.tableRef.current.dataManager.changeTreeExpand(rowData.tableData.path);
          }

          if (this.expandedTrees.indexOf(rowData.id) === -1) {
            this.expandedTrees.push(rowData.id);
          }

          this.path = rowData.path;
          this.tableRef.current.setState({
            ...this.tableRef.current.dataManager.getRenderState(),
            showAddRow: true
          });
        }
      },
      {
        icon: () => <VisibilityIcon color='primary' />,
        tooltip: props.intl.formatMessage({ id: 'base.deactivate' }),
        onClick: (event, rowData) => {
          const newData = Object.assign({}, rowData);
          newData.active = !newData.active;
          this.onRowUpdate(newData, rowData);
        }
      }
    ];

    this.expandedTrees = [];

    this.whitelistedKeys = [
      'image',
      'name',
      'cost',
      'costPerkg',
      'co2Perkg',
      'active',
      'label',
      'parentId',
      'registerPerItem',
      'amount',
      'defaultAmount',
      'labels'
    ];
  }

  componentDidMount(): void {
    window.addEventListener('keyup', this.onKeyUp);
    this.props.getLabels();
  }

  componentWillUnmount(): void {
    window.removeEventListener('keyup', this.onKeyUp);
  }

  formattedLabelName = (label: Label): string =>
    label.type === 'system'
      ? this.props.intl.formatMessage({ id: `label.system.${label.name}` })
      : label.name;
  getLabelById = (labelId: string) =>
    this.props.accountLabels.find((label) => label.id === labelId);

  /**
   * KeyUp handler: Cancels the Edit Row
   * */
  onKeyUp = (event): void => {
    if (event.which === 27) {
      // If Esc key is pressed
      const mode = this.tableRef.current.state.showAddRow ? 'add' : 'update';

      this.tableRef.current.onEditingCanceled(mode);
      this.onCancelHandler();
    }
  };

  /**f
   * Takes the registration-points data coming from the endpoint, parses it,
   * and starts setting up the columns based on the fields.
   * @returns { Column[] } - array of columns that will be passed as a prop to MT
   * */
  extractColumnsFromData = (): Column<RegistrationPoint>[] => {
    const disabledColumns = ['active', 'costPerkg'];
    const enabledColumns = this.whitelistedKeys.filter(
      (key) => disabledColumns.indexOf(key) === -1
    );

    return enabledColumns.map((key) => {
      switch (key) {
        case 'name':
          return this.setupNameColumn(key);
        case 'image':
          return this.setupImageColumn(key);
        case 'cost':
          return this.setupCostColumn(key);
        case 'co2Perkg':
          return this.setupCO2PerKgColumn(key);
        case 'costPerkg':
          return this.setupCostPerKgColumn(key);
        case 'label':
          return this.setupLabelColumn(key);
        case 'parentId':
          return this.setupParentColumn(key);
        case 'registerPerItem':
          return this.setupRegisterPerItemColumn(key);
        case 'amount':
          return this.setupAmountColumn(key);
        case 'defaultAmount':
          return this.setupDefaultAmountColumn(key);
        case 'labels':
          return this.setupLabelsColumn(key);
        default:
          return this.setupDefaultColumn(key);
      }
    });
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @returns { Column } - object including properties needed to custom-render the field in the table
   * */
  setupDefaultColumn = (key): Column<RegistrationPoint> => {
    const { intl } = this.props;

    return {
      title: intl.formatMessage({ id: key }),
      field: key
    };
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @returns { Column } - object including properties needed to custom-render the field in the table
   * */
  setupLabelColumn = (key): Column<RegistrationPoint> => {
    const { intl, width } = this.props;

    return {
      title: intl.formatMessage({ id: key }),
      field: key,
      headerStyle: {
        ...columnWidthMap.small
      },
      cellStyle: {
        ...columnWidthMap.small
      },
      hidden: width === 'xs' || width === 'sm',
      render: this.renderLabelColumn,
      editComponent: (props) => this.renderLabelEditMode(props, key)
    };
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @returns { Column } - object including properties needed to custom-render the field in the table
   * */
  setupParentColumn = (key): Column<RegistrationPoint> => {
    const { width } = this.props;

    return {
      title: '',
      field: key,
      headerStyle: {
        ...columnWidthMap.default
      },
      cellStyle: {
        ...columnWidthMap.default
      },
      hidden: width === 'xs' || width === 'sm',
      sorting: false,
      render: () => <span />,
      editComponent: (props) => this.renderParentEditMode(props, key)
    };
  };

  /**
   * Renders the data for the 'Label' column
   * @param { rowData } - row data
   * @returns { string | JSX.Element } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  renderLabelColumn = (rowData): string | JSX.Element => {
    const { intl } = this.props;

    return <span>{intl.formatMessage({ id: rowData.label })}</span>;
  };

  /**
   * Renders the custom edit component for the 'Label' column
   * @param { props } - props
   * @param { key } - the key
   * @returns { JSX.Element } - the element that should be rendered instead of the default edit component provided by MT
   * */
  renderLabelEditMode = (props, key): JSX.Element => {
    const { intl } = this.props;
    const { id, children: childrenRows } = props.rowData;
    const { value = AREA } = props;
    const uniqueChildrenLabels = (
      childrenRows ? [...new Set(childrenRows.map((row) => row.label))] : []
    ) as Labels[];
    const allowedLabels = getAllowedLabels(this.parentLabel, uniqueChildrenLabels);
    const idKey = `label-${id ? id : 'new-point'}`;

    return (
      <FormControl style={{ marginTop: '-6px' }}>
        <InputLabel id={idKey}>{intl.formatMessage({ id: 'label' })}</InputLabel>
        <Select
          id={idKey}
          required={true}
          value={value}
          name='regPointLabel'
          autoWidth={true}
          label={intl.formatMessage({ id: key })}
          onChange={(e, child: React.ReactNode) => {
            props.onChange(e.target.value);
          }}
        >
          {LABELS.map((element: string, index: number) => (
            <MenuItem
              disabled={allowedLabels.indexOf(element as Labels) === -1}
              value={element}
              key={`label_${index}`}
              selected={element === value}
            >
              {intl.formatMessage({ id: element })}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  /**
   * Renders the custom edit component for the 'Parent' column
   * @param { props } - props
   * @param { key } - the key
   * @returns { JSX.Element } - the element that should be rendered instead of the default edit component provided by MT
   * */
  renderParentEditMode = (props, key): JSX.Element => {
    const isNewRow = !props.rowData.id;
    const { intl, registrationPoints, registrationPointsMap } = this.props;
    const {
      label = PRODUCT,
      id = null,
      parentId: changedParentId = this.parentId ? this.parentId : null
    } = props.rowData;
    const { parentId: originalParentId = null } = !isNewRow ? registrationPointsMap.get(id) : {};
    const possibleParentLabels = [...getParentLabels(label), label];
    const possibleParents = [
      {
        id: NO_ID,
        name: intl.formatMessage({ id: 'topLevel' })
      },
      ...registrationPoints.filter(
        (regPoint) => possibleParentLabels.indexOf(regPoint.label) !== -1 && regPoint.id !== id
      )
    ];

    const value = changedParentId ? changedParentId : possibleParents[0].id;
    const idKey = `point-parent-${id ? id : 'new'}`;
    return (
      <div style={{ display: 'flex', minWidth: '160px' }}>
        <FormControl style={{ marginTop: '-6px' }}>
          <InputLabel id={idKey}>{intl.formatMessage({ id: key })}</InputLabel>
          <Select
            id={idKey}
            required={true}
            value={value}
            name='regPointParent'
            autoWidth={true}
            label={intl.formatMessage({ id: key })}
            onChange={this.onSelectParentChange(props)}
          >
            {possibleParents.map((element: RegistrationPoint, index: number) => {
              const isChecked = changedParentId ? element.id === changedParentId : index === 0;
              const isOriginalValue = originalParentId
                ? element.id === originalParentId
                : !isNewRow && index === 0;
              const indentation = 60 + (element.path ? 25 * element.path.split('.').length : 0);

              return (
                <MenuItem
                  style={{ fontWeight: index === 0 ? 'bold' : 'normal', paddingLeft: indentation }}
                  disabled={isOriginalValue}
                  value={element.id}
                  key={`parent_${element.id}`}
                  selected={isChecked}
                >
                  {element.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <HelpText size='small' helpText={intl.formatMessage({ id: 'help.settings.parent' })} />
      </div>
    );
  };

  onSelectParentChange = (props) => (e, child: React.ReactNode) => {
    const { registrationPointsMap } = this.props;
    const regPointId = e.target.value;
    const { label: newParentLabel } =
      regPointId !== NO_ID ? registrationPointsMap.get(regPointId) : { label: AREA };
    this.parentLabel = newParentLabel as Labels;

    props.onChange(regPointId === NO_ID ? null : regPointId);
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @param { key }
   * @returns { Column } - object including properties needed to custom-render the field in the table
   * */
  setupNameColumn = (key): Column<RegistrationPoint> => {
    const { intl } = this.props;

    return {
      title: intl.formatMessage({ id: key }),
      field: key,
      cellStyle: {
        position: 'relative',
        whiteSpace: 'pre'
      },
      headerStyle: {
        paddingLeft: 28
      },
      customSort: (a, b) => {
        return a.name.localeCompare(b.name, intl.locale, { sensitivity: 'base' });
      },
      render: this.renderNameColumn,
      editComponent: (props) => this.renderNameEditMode(props, key)
    };
  };

  /**
   * Renders the data for the 'Name' column
   * @param { rowData } - row data
   * @returns { string | JSX.Element } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  renderNameColumn = (rowData): string | JSX.Element => {
    const { intl } = this.props;
    const isNewRow = this.newRow === rowData.id;
    const transitionDuration = isNewRow ? '0.3' : '1';
    const opacityValue = isNewRow ? 1 : 0;
    const checkIconStyle = {
      transition: 'opacity ' + transitionDuration + 's ease-out 1s',
      opacity: opacityValue,
      width: 20,
      height: 20,
      verticalAlign: 'bottom',
      marginLeft: 10
    };

    this.newRow = this.newRow === rowData.id ? undefined : this.newRow;

    const canCreateIngredient = rowData.label === 'product' && rowData.registerPerItem;

    return (
      <>
        {!rowData.active ? (
          <span style={{ transition: 'opacity 300ms ease-out', opacity: 0.4 }}>
            {rowData.name}
            <Tooltip
              className={'tooltip'}
              title={intl.formatMessage({ id: 'help.settings.content.registrationPoints' })}
              enterTouchDelay={50}
              leaveTouchDelay={2500}
            >
              <VisibilityOffIcon
                htmlColor={'#000'}
                style={{
                  cursor: 'help',
                  width: 15,
                  height: 15,
                  verticalAlign: 'text-bottom',
                  marginLeft: 5
                }}
              />
            </Tooltip>
          </span>
        ) : (
          <span>
            {rowData.name}
            {canCreateIngredient && (
              <Tooltip
                className={'tooltip'}
                title={intl.formatMessage({ id: 'settings.ingredients.add' })}
              >
                <IconButton
                  size='small'
                  onClick={(e: any) => this.onCreateNewIngredient(e, rowData.id)}
                  style={{ marginLeft: '8px' }}
                >
                  <AddShoppingCartIcon fontSize='small' />
                </IconButton>
              </Tooltip>
            )}
          </span>
        )}
        <CheckIcon htmlColor={palette.primary1Color} style={checkIconStyle} />
      </>
    );
  };

  /**
   * Renders the custom edit component for the 'Name' column
   * @param { props } - props
   * @param { key } - the key
   * @returns { JSX.Element } - the element that should be rendered instead of the default edit component provided by MT
   * */
  renderNameEditMode = (props, key): JSX.Element => {
    const { intl } = this.props;

    return (
      <Input
        type={'text'}
        shouldValidate={(value: string) => {
          return value ? this.isValidData(props.rowData, key) && value.trim().length > 0 : false;
        }}
        required
        value={props.value}
        focusOnMount={true}
        name={`${key}_field`}
        style={{ minWidth: '120px', width: '50%', marginTop: '-6px', height: '48px' }}
        label={intl.formatMessage({ id: `${key}` })}
        onKeyDown={(event) => this.onInputKeyDown(event, props)}
        onChange={(e: any, value: string) => props.onChange(value)}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  /*
   *
   *
   * */
  isValidData = (rowData, key) => {
    const validation = validate('registration-point-create-request', rowData);
    return !validation.erroneousKeys.has(key);
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @param { key }
   * @returns { Column } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  setupCostColumn = (key): Column<RegistrationPoint> => {
    const { intl, currency, unit } = this.props;

    return {
      title: `${intl.formatMessage({ id: key })} (${currency}/${unit})`,
      field: key,
      headerStyle: {
        ...columnWidthMap.default
      },
      cellStyle: {
        ...columnWidthMap.default
      },
      editComponent: (props) => this.renderCostEditMode(props, key),
      render: (rowData) => {
        const isTotalValue =
          rowData.label === 'product' && rowData.registerPerItem && rowData.ingredients.length > 0;
        return isTotalValue ? (
          <span style={{ fontWeight: 'bold' }}>{formatMoney(rowData['costPerkg']).toString()}</span>
        ) : (
          formatMoney(rowData[key]).toString()
        );
      }
    };
  };

  /**
   * Renders the custom edit component for the 'Cost' column
   * @param { props } - props
   * @param { key } - the key
   * @returns { JSX.Element } - the element that should be rendered instead of the default edit component provided by MT
   * */
  renderCostEditMode = (props, key): JSX.Element => {
    const { intl, currency, unit } = this.props;
    const { rowData } = props;
    let costValue = props.value;

    const editLocked =
      rowData.label === 'product' && rowData.registerPerItem && rowData.ingredients?.length > 0;
    let floatValue = formatMoney(editLocked ? rowData.costPerkg : costValue).value;

    return (
      <NumberInput
        value={props.value ? floatValue : props.value}
        type={'text'}
        shouldValidate={() => {
          return this.isValidData(props.rowData, key);
        }}
        component={TextField}
        allowNegative={false}
        name={`${key}_field`}
        style={{ minWidth: '120px', marginTop: '-6px', height: '48px' }}
        onValueChange={this.onCostValueChange(props)}
        label={`${intl.formatMessage({ id: `${key}` })} (${currency}/${unit})`}
        onKeyDown={(event) => this.onInputKeyDown(event, props)}
        currency
        disabled={editLocked}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  onCostValueChange = (props) => (values: NumberFormatValues) => {
    const floatValue = values.floatValue;

    props.onChange(formatMoney(floatValue, { inMajorUnit: true }).inMinorUnits);
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @param { key }
   * @returns { Column } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  setupAmountColumn = (key): Column<RegistrationPoint> => {
    const { intl } = this.props;

    return {
      title: intl.formatMessage({ id: 'settings.registrationPoints.amountPerItem' }),
      field: key,
      headerStyle: {
        ...columnWidthMap.small
      },
      cellStyle: {
        ...columnWidthMap.small
      },
      editComponent: (props) => this.renderAmountEditMode(props, key),
      render: (rowData) => {
        return rowData.label === 'product' && rowData.registerPerItem ? (
          rowData.ingredients.length > 0 ? (
            <span style={{ fontWeight: 'bold' }}>{formatWeight(rowData[key])}</span>
          ) : (
            formatWeight(rowData[key])
          )
        ) : (
          '-'
        );
      }
    };
  };

  /**
   * Renders the custom edit component for the 'Amount' column
   * @param { props } - props
   * @param { key } - the key
   * @returns { JSX.Element } - the element that should be rendered instead of the default edit component provided by MT
   * */
  renderAmountEditMode = (props, key) => {
    const { intl } = this.props;
    const { rowData } = props;
    let massFloat = formatMass(props.value);

    const editLocked =
      !rowData.registerPerItem ||
      (rowData.label === 'product' && rowData.registerPerItem && rowData.ingredients?.length > 0);

    return (
      <NumberInput
        required
        value={props.value ? massFloat : props.value}
        type={'text'}
        shouldValidate={() => {
          return this.isValidData(props.rowData, key);
        }}
        component={TextField}
        allowNegative={false}
        inputMode={'decimal'}
        name={`${key}_field`}
        style={{ minWidth: '100px', marginTop: '-6px' }}
        label={`${intl.formatMessage({ id: 'settings.registrationPoints.amountPerItemLabel' })}`}
        onValueChange={this.onAmountValueChange(props)}
        onKeyDown={(event) => this.onInputKeyDown(event, props)}
        disabled={editLocked}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  setupDefaultAmountColumn = (key): Column<RegistrationPoint> => {
    const { intl } = this.props;

    return {
      title: intl.formatMessage({ id: 'settings.registrationPoints.defaultAmount' }),
      field: key,
      headerStyle: {
        ...columnWidthMap.large
      },
      cellStyle: {
        ...columnWidthMap.large
      },
      editComponent: (props) => this.renderDefaultAmountEditMode(props, key),
      render: (rowData) => (rowData[key] ? formatWeight(rowData[key]) : '-')
    };
  };

  renderDefaultAmountEditMode = (props, key) => {
    const { intl } = this.props;
    let massFloat = formatMass(props.value);

    return (
      <NumberInput
        required
        value={props.value ? massFloat : props.value}
        type='text'
        shouldValidate={() => this.isValidData(props.rowData, key)}
        component={TextField}
        allowNegative={false}
        placeholder='-'
        inputMode='decimal'
        name={`${key}_field`}
        style={{ minWidth: '120px', marginTop: '-6px' }}
        label={intl.formatMessage({ id: 'settings.registrationPoints.defaultAmount' })}
        onValueChange={(change) =>
          props.onChange(change.floatValue ? unformatMass(change.floatValue) : null)
        }
        onKeyDown={(event) => this.onInputKeyDown(event, props)}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  setupLabelsColumn = (key): Column<RegistrationPoint> => {
    const { intl } = this.props;

    return {
      title: intl.formatMessage({ id: 'settings.registrationPoints.labels' }),
      field: key,
      headerStyle: {
        ...columnWidthMap.large
      },
      cellStyle: {
        ...columnWidthMap.large,
        maxWidth: 'auto'
      },
      editComponent: (props) => this.renderLabelsEditMode(props, key),
      render: (rowData) =>
        (rowData.labels ?? []).map((label) => (
          <Chip
            key={label.id}
            label={this.formattedLabelName(label)}
            size='small'
            style={{ marginRight: 2, marginTop: 2 }}
          />
        ))
    };
  };

  handleOpenNewLabelForm = () => {
    this.props.showModal({
      title: this.props.intl.formatMessage({ id: 'settings.registrationPoints.createLabel' }),
      content: (
        <CreateNewLabelForm onCreate={this.handleCreateLabel} closeModal={this.props.closeModal} />
      )
    });
  };

  renderLabelsEditMode = (props, key): JSX.Element => {
    const { intl } = this.props;
    const { id } = props.rowData;
    const { value = [] } = props;
    const { accountLabels = [], loadingLabels } = this.props;
    const idKey = `labels-${id ? id : 'new-point'}`;
    const normalizedValue = value.map((v) => (typeof v === 'object' ? v.id : v));

    return (
      <FormControl style={{ marginTop: '-6px' }}>
        <InputLabel id={idKey}>{intl.formatMessage({ id: 'labels' })}</InputLabel>
        <Select
          id={idKey}
          value={normalizedValue}
          multiple
          disabled={loadingLabels}
          label={intl.formatMessage({ id: key })}
          onChange={(e) => {
            const values = e.target.value as string[];
            if (values.includes('create-new-label')) {
              this.handleOpenNewLabelForm();
              return;
            }
            props.onChange(values);
          }}
          renderValue={(selected: string[]) => (
            <span>
              {selected.map((l) => (
                <Chip
                  key={l}
                  label={this.formattedLabelName(this.getLabelById(l))}
                  size='small'
                  style={{ marginRight: 2 }}
                />
              ))}
            </span>
          )}
        >
          {accountLabels.map((label: Label) => {
            return (
              <MenuItem key={`label_${label.id}`} value={label.id}>
                {this.formattedLabelName(label)}
              </MenuItem>
            );
          })}
          <Divider />
          <MenuItem key='create-new-label' value='create-new-label'>
            <ListItemIcon>
              <AddIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({ id: 'settings.registrationPoints.createLabel' })}
            />
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  onAmountValueChange = (props) => (values: NumberFormatValues) => {
    const massFloat = values.floatValue;
    props.onChange(unformatMass(massFloat));
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @param { key }
   * @returns { Column } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  setupImageColumn = (key): Column<RegistrationPoint> => {
    const { intl, width } = this.props;

    return {
      title: intl.formatMessage({ id: key }),
      field: key,
      headerStyle: {
        width: 80,
        textAlign: 'center',
        fontFamily: '"Roboto", "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
        letterSpacing: '0.024em'
      },
      cellStyle: {
        width: 80,
        position: 'relative',
        textAlign: 'center'
      },
      hidden: width === 'xs' || width === 'sm',
      sorting: false,
      disableClick: true,
      editComponent: (props) => {
        return this.renderImageContent(props.rowData, props, true);
      },
      render: (rowData) => {
        return this.renderImageContent(rowData, null);
      }
    };
  };

  setupCO2PerKgColumn = (key): Column<RegistrationPoint> => {
    return {
      title: <FormattedMessage id={key} values={{ sub: (chunks) => <sub>{chunks}</sub> }} />,
      field: key,
      headerStyle: {
        ...columnWidthMap.default
      },
      cellStyle: {
        ...columnWidthMap.default
      },
      editComponent: (props) => {
        const { rowData } = props;
        let costValue = props.value;
        let floatValue = formatWeight(costValue);

        const editLocked =
          rowData.label === 'product' && rowData.registerPerItem && rowData.ingredients?.length > 0;

        return (
          <NumberInput
            required
            value={floatValue}
            type={'text'}
            style={{ minWidth: '100px', marginTop: '-6px' }}
            component={TextField}
            onChange={(e) => {
              props.onChange(unformat(e.target.value) * 1000);
            }}
            inputMode={'decimal'}
            allowNegative={false}
            min={1}
            name={`${key}_field`}
            label={<FormattedMessage id={key} values={{ sub: (chunks) => <sub>{chunks}</sub> }} />}
            disabled={editLocked}
            InputLabelProps={{ shrink: true }}
          />
        );
      },
      render: (rowData) => {
        return rowData[key] ? (
          rowData.label === 'product' &&
          rowData.registerPerItem &&
          rowData.ingredients.length > 0 ? (
            <span style={{ fontWeight: 'bold' }}>{formatWeight(rowData[key])}</span>
          ) : (
            formatWeight(rowData[key])
          )
        ) : (
          '-'
        );
      }
    };
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @param { key }
   * @returns { Column } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  setupCostPerKgColumn = (key): Column<RegistrationPoint> => {
    const { intl, currency, unit } = this.props;

    return {
      title: `${intl.formatMessage({ id: key })} (${currency}/${unit})`,
      field: key,
      headerStyle: {
        ...columnWidthMap.default
      },
      cellStyle: {
        ...columnWidthMap.default
      },
      editComponent: (props) => {
        const { intl, currency, unit } = this.props;
        const { rowData } = props;
        let costValue = props.value;
        let floatValue = formatMoney(costValue).value;

        const editLocked =
          rowData.label === 'product' && rowData.registerPerItem && rowData.ingredients?.length > 0;

        return (
          <NumberInput
            value={props.value ? floatValue : props.value}
            type={'text'}
            shouldValidate={() => {
              return this.isValidData(props.rowData, key);
            }}
            component={TextField}
            allowNegative={false}
            name={`${key}_field`}
            style={{ minWidth: '120px', marginTop: '-6px', height: '48px' }}
            onValueChange={this.onCostValueChange(props)}
            label={`${intl.formatMessage({ id: `${key}` })} (${currency}/${unit})`}
            onKeyDown={(event) => this.onInputKeyDown(event, props)}
            currency
            disabled={editLocked}
            InputLabelProps={{ shrink: true }}
          />
        );
      },
      render: (rowData) => {
        const isTotalValue =
          rowData.label === 'product' && rowData.registerPerItem && rowData.ingredients.length > 0;
        return isTotalValue ? (
          <span style={{ fontWeight: 'bold' }}>{formatMoney(rowData[key]).toString()}</span>
        ) : (
          formatMoney(rowData[key]).toString()
        );
      }
    };
  };

  /**
   * Returns an object with needed data for custom-rendering
   * @param { key }
   * @returns { Column } - object including properties needed to custom-render the field in the table
   * */
  setupRegisterPerItemColumn = (key): Column<RegistrationPoint> => {
    const { intl } = this.props;

    return {
      title: intl.formatMessage({ id: key }),
      field: key,
      cellStyle: {
        ...columnWidthMap.small
      },
      headerStyle: {
        ...columnWidthMap.small
      },
      render: this.renderRegisterPerItemColumn,
      editComponent: (props) => this.renderRegisterPerItemEditMode(props, key)
    };
  };

  /**
   * Renders the data for the 'Name' column
   * @param { rowData } - row data
   * @returns { string | JSX.Element } - returns the value needed to be rendered, or the value together with an icon if it's a newly added row
   * */
  renderRegisterPerItemColumn = (rowData): string | JSX.Element => {
    const { intl } = this.props;

    return (
      <FormControlLabel
        control={<Switch color={'primary'} size='small' checked={rowData.registerPerItem} />}
        style={{ marginLeft: '0px' }}
        label={intl.formatMessage({ id: `${rowData.registerPerItem ? 'yes' : 'no'}` })}
      />
    );
  };

  /**
   * Renders the custom edit component for the 'Name' column
   * @param { props } - props
   * @param { key } - the key
   * @returns { JSX.Element } - the element that should be rendered instead of the default edit component provided by MT
   * */
  renderRegisterPerItemEditMode = (props, key): JSX.Element => {
    const { intl } = this.props;

    return (
      <>
        <FormControlLabel
          control={
            <Switch
              color={'primary'}
              size='small'
              checked={props.rowData.registerPerItem}
              onChange={(e, isInputChecked) => {
                props.onChange(isInputChecked);
              }}
            />
          }
          style={{ marginRight: '2px', marginLeft: '0px' }}
          label={intl.formatMessage({ id: `${props.rowData.registerPerItem ? 'yes' : 'no'}` })}
        />
        <HelpText
          size='small'
          helpText={intl.formatMessage({ id: 'help.settings.registerPerItem' })}
        />
      </>
    );
  };

  /**
   * Renders the 'Image' column in non-Edit mode, in both scenarios (if an image exists or not)
   * @param { rowData } - row data
   * @returns { JSX.Element } - returns the element that should be rendered (either a thumbnail or the default icon)
   * */
  renderImageContent = (rowData, props, editMode?: boolean): JSX.Element => {
    const { intl } = this.props;
    return (
      <Tooltip
        title={intl.formatMessage({ id: 'settings.uploadImage' })}
        aria-label={intl.formatMessage({ id: 'settings.uploadImage' })}
      >
        <IconButton
          onClick={() =>
            this.onImageClickHandler(rowData, (newData) => {
              if (newData.id) {
                this.onRowUpdate(newData, rowData);
              } else {
                props.onChange(newData.image);
              }
            })
          }
          style={{
            margin: '0 auto',
            position: 'relative',
            display: 'block',
            padding: rowData.image && 0
          }}
        >
          {rowData.image ? (
            <img
              className='thumbnail'
              src={rowData.image}
              style={{
                height: editMode ? '50px' : '37px',
                width: editMode ? '50px' : '37px',
                borderRadius: '4px',
                cursor: 'pointer',
                verticalAlign: 'middle'
              }}
            />
          ) : (
            <AddPhotoIcon htmlColor={colors.grey['400']} />
          )}
        </IconButton>
      </Tooltip>
    );
  };

  /**
   *
   * @param { data } - row data
   * @param { callBack } - row data
   * */
  onImageClickHandler(
    rowData: RegistrationPoint,
    callBack: (data: RegistrationPoint) => void
  ): void {
    this.props.showModal({
      title: null,
      fullBleed: true,
      className: 'imageGallery',
      size: 'md',
      fullWidth: true,
      disablePadding: true,
      content: (
        <ImageGallery
          imageUrl={rowData.hasOwnProperty('image') ? rowData.image : null}
          onSelection={(image: any) => {
            const newData = Object.assign({}, rowData);

            newData.image = image.url;
            callBack(newData);
          }}
        />
      )
    });
  }

  /**
   * Checks whether the user pressed Enter or Escape, and approve or cancel the editing depending on the action
   *
   * @param { event }
   * @param { props }
   * */
  onInputKeyDown = (event, props): void => {
    const mode = this.tableRef.current.state.showAddRow ? 'add' : 'update';

    if (event.which === 13) {
      if (props.rowData.name && props.rowData.name.trim().length) {
        this.tableRef.current.onEditingApproved(
          mode,
          props.rowData,
          this.tableRef.current.state.lastEditingRow
        );
        if (mode === 'update') {
          return this.onSubmitHandler(props.rowData);
        }
      }
    }
  };

  /**
   * Sets the correct VisibilityIcon icon depending on the 'active' property
   *
   * @param { props }
   * */
  setCorrectVisibilityIcon = (props) => {
    const { intl } = this.props;

    if (props.actions.length === 0) {
      return;
    }

    if (!props.data.active) {
      props.actions[1].icon = () => <VisibilityOffIcon style={{ color: colors.grey['400'] }} />;
      props.actions[1].tooltip = intl.formatMessage({ id: 'base.activate' });
    } else {
      props.actions[1].icon = () => <VisibilityIcon color={'primary'} />;
      props.actions[1].tooltip = intl.formatMessage({ id: 'base.deactivate' });
    }
  };

  handleCreateLabel = (label: CreateLabel) => {
    void this.props.createLabel(label).then(() => this.props.closeModal());
  };

  handleDelete = (id: string) => {
    void this.props.deleteIngredient(id);
  };

  handleCreate = (ingredient: CreateIngredient) => {
    void this.props.createIngredient(ingredient);
  };

  handleUpdate = (ingredientId: string, patch: IPatchObject[]) => {
    void this.props.updateIngredient(ingredientId, patch);
  };

  onCreateNewIngredient = (e: MouseEvent, registrationPontId: string) => {
    e.stopPropagation();
    const tableRef = this.props.ingredientTableRefMap[registrationPontId];
    tableRef.current.onEditingCanceled('update');
    this.hideAddNewRow();

    tableRef.current.setState({
      ...tableRef.current.dataManager.getRenderState(),
      showAddRow: true
    });
  };

  /**
   * Override the default MT table row with a custom one, and render it.
   * The custom row is a copy of the original, with some small code adjustments.
   *
   * @param { props }
   * */
  overrideTableRow = (props): JSX.Element => {
    const rowData = props.data;
    const isTreeExpanded = this.expandedTrees.includes(rowData.id)
      ? true
      : rowData.tableData.isTreeExpanded;
    const hasEditRow =
      this.tableRef.current &&
      this.tableRef.current.state.showAddRow &&
      this.parentId === props.data.id;
    const isRowUpdatedOrNew = this.updatedRow === props.data.id || this.newRow === props.data.id;

    // CRAS: This is an MT bug. (https://github.com/mbrn/material-table/issues/1442)
    // The path stored in rowData.tableData.path is incorrect when sorting the table, while props.path is correct.
    // As a quick fix, I'm overwriting the wrong path with the correct one.
    rowData.tableData.path = props.path;

    this.setCorrectVisibilityIcon(props);
    this.updatedRow = this.updatedRow === props.data.id ? undefined : this.updatedRow;

    if (isTreeExpanded !== rowData.tableData.isTreeExpanded) {
      this.tableRef.current.dataManager.changeTreeExpand(rowData.tableData.path);
    }

    const showIngredients = rowData.label === 'product' && rowData.registerPerItem;
    const tableRef = this.props.ingredientTableRefMap[rowData.id];

    return (
      <>
        <CustomTableRow
          {...props}
          onTreeExpandClick={this.onTreeExpandClick}
          id={isRowUpdatedOrNew ? NEW_OR_UPDATED_ROW : null}
        />
        {hasEditRow && this.renderEditRow(props)}
        {showIngredients && (
          <TableRow>
            <TableCell style={{ padding: '0', borderBottom: 'none' }} colSpan={12}>
              <IngredientTable
                tableRef={tableRef}
                registrationPointId={rowData.id}
                ingredients={rowData.ingredients}
                onDelete={this.handleDelete}
                onCreate={this.handleCreate}
                onUpdate={this.handleUpdate}
              />
            </TableCell>
          </TableRow>
        )}
      </>
    );
  };

  /**
   * Render an Edit Row
   *
   * @param { props }
   * */
  renderEditRow = (props): JSX.Element => {
    return (
      <props.components.EditRow
        columns={props.columns.filter((columnDef) => {
          return !columnDef.hidden;
        })}
        data={props.initialFormData}
        components={props.components}
        icons={props.icons}
        key='key-add-row'
        mode='add'
        localization={{
          // @ts-ignore
          ...MTableBody.defaultProps.localization.editRow,
          ...props.localization.editRow
        }}
        options={props.options}
        isTreeData={props.isTreeData}
        detailPanel={props.detailPanel}
        onEditingCanceled={props.onEditingCanceled}
        onEditingApproved={props.onEditingApproved}
        getFieldValue={props.getFieldValue}
      />
    );
  };

  /**
   * Override the default MT table body with a custom one, and render it.
   * This is needed to block the default behaviour that renders an Edit row at the end or beginning of the table body.
   *
   * @param { props }
   * */
  overrideTableBody = (props): JSX.Element => {
    return <CustomTableBody {...props} parentId={this.parentId} />;
  };

  /**
   * Override the default MT table head with a custom one, and render it.
   *
   * @param { props }
   * */
  overrideTableHead = (props): JSX.Element => {
    return <CustomTableHead {...props} fixedActionsHeaderWidth={false} draggable={false} />;
  };

  /**
   * Override the default MT Overlay with an empty <span> in order to 'deactivate' it
   *
   * @param { props }
   * */
  overrideOverlay = (props): JSX.Element => <span />;

  /**
   * Override the default MT table edit row with a custom one, and render it.
   *
   * @param { props }
   * */
  overrideEditRow = (props): JSX.Element => {
    let deleteConfirmationText;
    const { data: rowData } = props;
    const isNewRow = !rowData;

    const { registrationPointsMap } = this.props;
    const parentId = rowData && rowData.parentId ? rowData.parentId : this.parentId;
    const parentRow = registrationPointsMap.get(parentId);
    const slidingIn =
      props.data && props.data.id && props.data.id === this.deletedRow ? false : true;
    const slideDuration =
      props.data && props.data.id && props.data.id === this.deletedRow
        ? deleteTransitionDuration
        : 0;
    this.parentLabel = (parentRow && parentRow.label) as Labels;

    if (props.mode === 'delete') {
      const { intl } = this.props;

      deleteConfirmationText = intl.formatMessage(
        { id: 'settings.content.deleteConfirmation' },
        { registrationPoint: props.data.name }
      );
    }

    const proxyProps = { ...props, data: isNewRow ? { label: 'area' } : rowData };

    return (
      <Slide in={slidingIn} direction={'left'} timeout={slideDuration}>
        <CustomEditRow
          {...proxyProps}
          parentId={this.parentId}
          path={this.path}
          disableEdit={(registration: any) => !registration?.name?.trim()}
          deleteConfirmationText={deleteConfirmationText}
          onCancelHandler={this.onCancelHandler}
          onSubmitHandler={this.onSubmitHandler}
        />
      </Slide>
    );
  };

  /**
   * Override the default MT table action with a custom one, and render it.
   *
   * @param { props }
   * */
  overrideAction = (props): JSX.Element => {
    const { intl, contentType } = this.props;
    const buttonTitleAdd = intl.formatMessage(
      { id: 'settings.content.add' },
      { contentType: intl.formatMessage({ id: contentType }) }
    );
    const { action, ...rest } = props;
    let customAction;

    // When clicking on the global "Add Registration Point" button, cancel any edit rows before adding a new row.
    if (action.isFreeAction) {
      customAction = Object.assign({}, action);

      customAction.onClick = () => {
        this.tableRef.current.onEditingCanceled('update');
        this.hideAddNewRow();

        this.tableRef.current.setState({
          ...this.tableRef.current.dataManager.getRenderState(),
          showAddRow: true
        });
      };
    }

    return (
      !this.props.hasRegistrationPointsLocked && (
        <CustomTableAction
          {...rest}
          action={customAction ? customAction : action}
          buttonTitleAdd={buttonTitleAdd}
        />
      )
    );
  };

  /**
   * Whenever an Edit row has been canceled, this callback is called
   *
   ** */
  onCancelHandler = (): void => {
    this.resetHelperGlobals();
  };

  /**
   * Whenever an Edit row has been approved (by Enter or clicking on the CheckIcon icon), this callback is called
   *
   * @param { data }
   **/
  onSubmitHandler = (data: RegistrationPoint, mode?: string): void => {
    if (mode === 'delete') {
      this.deletedRow = data.id;
    } else {
      this.updatedRow = data.id;
    }
  };

  /*
   * Reset some helper variables. This gets called when we cancel an Edit row.
   *
   * */
  resetHelperGlobals = (): void => {
    this.parentId = undefined;
    this.path = undefined;
    this.parentLabel = undefined;
    this.deletedRow = undefined;
  };

  /**
   * Clicking on a row triggers the Edit mode on that specific row
   *
   * @param { event }
   * @param { rowData }
   * */
  onRowClick = (event, rowData) => {
    if (
      !event.target.classList.contains('tooltip') &&
      !event.target.parentNode.classList.contains('tooltip')
    ) {
      this.tableRef.current.dataManager.changeRowEditing(rowData, 'update');
      this.hideAddNewRow();
    }
  };

  /**
   * Clicking on an arrow that expands/collapses the row to show/hide its children rows will trigger this callback
   *
   * @param { data }
   * @param { isTreeExpanded }
   * */
  onTreeExpandClick = (data, isTreeExpanded: boolean) => {
    this.hideAddNewRow();
    this.tableRef.current.onEditingCanceled('update');

    if (!isTreeExpanded && this.expandedTrees.indexOf(data.id) === -1) {
      this.expandedTrees.push(data.id);
    } else if (isTreeExpanded && this.expandedTrees.indexOf(data.id) !== -1) {
      this.expandedTrees.splice(this.expandedTrees.indexOf(data.id), 1);
      if (data.tableData.childRows && data.tableData.childRows.length) {
        this.collapseChildrenRows(data.tableData.childRows);
      }
    }
  };

  /**
   * Hides any existing edit rows which have the function of adding a new row
   *
   * */
  hideAddNewRow = () => {
    this.resetHelperGlobals();
    this.tableRef.current.setState({
      ...this.tableRef.current.dataManager.getRenderState(),
      showAddRow: false
    });
  };

  /**
   * Collapse the children rows found under a specific row that has just been closed.
   * This is a 'nice to have', so that it resets the view when you, for example,
   * close the root node, after expanding all its child nodes.
   *
   * @param { data }
   * */
  collapseChildrenRows(data) {
    data.map((child) => {
      this.expandedTrees.indexOf(child.id) !== -1 &&
        this.expandedTrees.splice(this.expandedTrees.indexOf(child.id), 1);

      if (child.tableData.isTreeExpanded) {
        this.tableRef.current.dataManager.changeTreeExpand(child.tableData.path);
      }

      if (child.tableData.childRows && child.tableData.childRows.length) {
        this.collapseChildrenRows(child.tableData.childRows);
      }
    });
  }

  /**
   * Expand the parent rows of an element with a specific parentId. Recursive.
   *
   * @param { parentId }
   * */
  expandParentRows = (parentId) => {
    if (parentId && this.expandedTrees.indexOf(parentId) === -1) {
      const { registrationPointsMap } = this.props;
      const parent = registrationPointsMap.get(parentId);

      this.expandedTrees.push(parentId);

      this.expandParentRows(parent.parentId);
    }
  };

  /**
   * Runs when an Edit row for a brand new row has been 'confirmed',
   * by pressing Enter or clicking on the CheckIcon icon.
   * Here we make the call to the endpoint with the data for the new row.
   *
   * @param { newData }
   * */
  onRowAdd = (newData) => {
    return new Promise<void>(async (resolve, reject) => {
      const { registrationPointsMap } = this.props;
      const parentId =
        newData.parentId !== undefined ? newData.parentId : this.parentId ? this.parentId : null;
      const parent = parentId && registrationPointsMap.get(parentId);

      newData.active = parent ? parent.active : newData.active;
      newData.parentId = parentId;

      await this.props
        .createRegistrationPoint(newData)
        .then((res) => (this.newRow = res.payload.id));
      this.expandParentRows(newData.parentId);
      await this.props.getRegistrationPoints();
      this.resetHelperGlobals();
      scrollToEl(NEW_OR_UPDATED_ROW);
      resolve();
    });
  };

  /**
   * Runs when an Edit row for an existing row has been 'confirmed',
   * by pressing Enter or clicking on the CheckIcon icon.
   * Here we make the call to the endpoint with the new data for the existing row.
   *
   * @param { newData }
   * */
  onRowUpdate = (newData, oldData) => {
    // If registerPerItem is set to false after previously being true, reset the amount field to default
    if (oldData.registerPerItem && !newData.registerPerItem) {
      newData.amount = 1000;
    }

    return new Promise<void>(async (resolve, reject) => {
      const patch = this.getPatchObject(newData, oldData);

      if (patch.length) {
        await this.props.updateRegistrationPoint(newData.id, patch);
        this.expandParentRows(newData.parentId);
        await this.props.getRegistrationPoints();
        scrollToEl(NEW_OR_UPDATED_ROW);
      } else {
        this.updatedRow = undefined;
      }
      this.resetHelperGlobals();
      resolve();
    });
  };

  /**
   * Returns the patch object based on the newData and oldData params
   *
   * @param { newData }
   * @param { oldData }
   * */
  getPatchObject = (newData, oldData) => {
    return this.whitelistedKeys.reduce((ops, key) => {
      if (key === 'labels') {
        if (JSON.stringify(newData.labels) !== JSON.stringify(oldData.labels)) {
          ops.push({ op: 'replace', path: '/labels', value: newData.labels });
        }
      } else if (oldData[key] !== newData[key]) {
        ops.push({ op: 'replace', path: `/${key}`, value: newData[key] });

        if (key === 'parentId') {
          // If the new parent is inactive, deactivate this point as well
          const { registrationPointsMap } = this.props;
          const { active: isParentActive } = registrationPointsMap.get(newData[key]) || {
            active: true
          };

          if (!isParentActive && newData['active']) {
            ops.push({ op: 'replace', path: '/active', value: isParentActive });
          }
        }
      }

      return ops;
    }, []);
  };

  /**
   * Runs when we confirmed deletion on an existing row.
   * Here we make the call to the endpoint with the data for the row we want to delete.
   *
   * @param { newData }
   * */
  onRowDelete = (oldData): Promise<void> => {
    return new Promise<void>(async (resolve, reject) => {
      await this.props.deleteRegistrationPoint(oldData.id).then((result) => {
        this.updatedRow = undefined;

        if (result.payload === oldData.name) {
          setTimeout(async () => {
            await this.props.getRegistrationPoints();
            this.resetHelperGlobals();
            resolve();
          }, deleteTransitionDuration - 200);
        } else {
          this.deletedRow = undefined;
          reject();
        }
      });
    });
  };

  handleChangeReasonOnly = (isChecked: boolean) => {
    if (isChecked) {
      this.props.updateSettings({
        allowReasonRegistrationsOnly: true,
        allowRegistrationsOnAnyPoint: false,
        allowMultipleRegistrations: false
      });
    } else {
      this.props.updateSettings({ allowReasonRegistrationsOnly: false });
    }
  };

  handleChangeReason = (isChecked: boolean) => {
    if (isChecked) {
      this.props.updateSettings({
        enableRegistrationReason: true,
        allowMultipleRegistrations: false,
        allowRegistrationsOnAnyPoint: false
      });
    } else {
      this.props.updateSettings({
        enableRegistrationReason: false,
        allowReasonRegistrationsOnly: false
      });
    }
  };

  render() {
    const {
      reasons,
      updateSettings,
      allowRegistrationsOnAnyPoint,
      enableRegistrationReason,
      registrationPoints,
      allowMultipleRegistrations,
      allowReasonRegistrationsOnly,
      enableRegistrationComments,
      enableAutomaticRegistrations,
      automaticRegistrationSchedule,
      intl,
      hasRegistrationPointsLocked,
      hasSubscribedAccounts,
      overrideChildSettings,
      enableLockedRegistrations,
      maxRegistrationAmount,
      lockedByAdmin
    } = this.props;
    const areReasonsDisabled =
      reasons.length === 0 || reasons.filter((reason) => reason.active === true).length === 0;

    return (
      <>
        <div className='setting setting--borderless'>
          <div className='settingToggle'>
            <HelpText helpText={intl.formatMessage({ id: 'help.settings.sound' })} />
            <FormControlLabel
              control={
                <div className='control'>
                  <SoundSelector updateSettings={updateSettings} />
                </div>
              }
              label={intl.formatMessage({ id: 'settings.sound' })}
            />
          </div>
          <div className='settingToggle'>
            <HelpText
              helpText={intl.formatMessage({ id: 'help.settings.allowRegistrationsOnAnyPoint' })}
            />
            <FormControlLabel
              control={
                <Switch
                  color='primary'
                  checked={allowRegistrationsOnAnyPoint}
                  onChange={(e, isInputChecked) => {
                    updateSettings({ allowRegistrationsOnAnyPoint: isInputChecked });
                  }}
                />
              }
              label={intl.formatMessage({
                id: 'settings.registrationPoints.allowRegistrationsOnAnyPoint'
              })}
            />
          </div>
          <div className='settingToggle'>
            <HelpText helpText={intl.formatMessage({ id: 'help.settings.allowReasons' })} />
            <FormControlLabel
              control={
                <Switch
                  color={'primary'}
                  checked={enableRegistrationReason}
                  onChange={(e, isInputChecked) => {
                    this.handleChangeReason(isInputChecked);
                  }}
                  disabled={areReasonsDisabled}
                />
              }
              label={intl.formatMessage({ id: 'settings.reasons.toggle' })}
            />
            {enableRegistrationReason && (
              <>
                <HelpText helpText={intl.formatMessage({ id: 'help.settings.allowReasonOnly' })}>
                  &nbsp;
                </HelpText>
                <FormControlLabel
                  disabled={!enableRegistrationReason}
                  control={
                    <Switch
                      color={'primary'}
                      checked={allowReasonRegistrationsOnly}
                      onChange={(e, isInputChecked) => {
                        this.handleChangeReasonOnly(isInputChecked);
                      }}
                    />
                  }
                  label={intl.formatMessage({ id: 'settings.reasons.allowReasonOnlyRegistration' })}
                />
              </>
            )}
          </div>
          <div className='settingToggle'>
            <HelpText
              helpText={intl.formatMessage({ id: 'help.settings.enableRegistrationComments' })}
            />
            <FormControlLabel
              control={
                <Switch
                  color='primary'
                  onChange={(e, isEnabled) => {
                    void updateSettings({ enableRegistrationComments: isEnabled });
                  }}
                  checked={enableRegistrationComments}
                />
              }
              label={intl.formatMessage({ id: 'settings.enableRegistrationComments' })}
            />
          </div>
          <div className='settingToggle'>
            <HelpText
              helpText={intl.formatMessage({ id: 'help.settings.allowMultipleRegistrations' })}
            />
            <FormControlLabel
              control={
                <Switch
                  color='primary'
                  checked={allowMultipleRegistrations}
                  onChange={(e, isInputChecked) => {
                    updateSettings({
                      allowMultipleRegistrations: isInputChecked,
                      enableRegistrationReason: false,
                      allowReasonRegistrationsOnly: false,
                      allowSkipLastRegistrationPoint: false,
                      overrideChildSettings: {
                        ...overrideChildSettings,
                        allowSkipLastRegistrationPoint: {
                          enabled: false,
                          overridePrevious: true
                        }
                      }
                    });
                  }}
                />
              }
              label={intl.formatMessage({
                id: 'settings.registrationPoints.allowMultipleRegistrations'
              })}
            />
          </div>
          <div className='settingToggle settingAutomaticRegistration'>
            <div>
              <HelpText
                helpText={intl.formatMessage({ id: 'help.settings.enableAutomaticRegistrations' })}
              />
              <FormControlLabel
                control={
                  <Switch
                    color='primary'
                    onChange={(e, isEnabled) => {
                      void updateSettings({
                        enableAutomaticRegistrations: isEnabled
                      });
                    }}
                    checked={enableAutomaticRegistrations ?? false}
                  />
                }
                label={intl.formatMessage({
                  id: 'settings.registrationPoints.enableAutomaticRegistrations'
                })}
              />
            </div>
            {enableAutomaticRegistrations && (
              <FormControlLabel
                labelPlacement='start'
                control={
                  <Select
                    style={{ marginLeft: '12px' }}
                    multiple
                    value={automaticRegistrationSchedule}
                    renderValue={(selected: string[]) =>
                      selected
                        .sort()
                        .map((dow) => moment.weekdays(dow))
                        .join(', ')
                    }
                    onChange={(e) => {
                      void updateSettings({
                        automaticRegistrationSchedule: e.target.value
                      });
                    }}
                  >
                    {DAYS_OF_WEEK.map((dow) => (
                      <MenuItem value={dow} key={`automatic_schedule_${dow}`}>
                        <Checkbox
                          color='primary'
                          checked={automaticRegistrationSchedule.includes(dow)}
                        />
                        {moment.weekdays(dow)}
                      </MenuItem>
                    ))}
                  </Select>
                }
                label={intl.formatMessage({
                  id: 'settings.registrationPoints.automaticRegisrationSchedule'
                })}
              />
            )}
          </div>
          <LockedRegistrationDays
            settings={{ enableLockedRegistrations, lockedByAdmin, overrideChildSettings }}
            onUpdateSettings={updateSettings}
            hasSubscribedAccounts={hasSubscribedAccounts}
          />
          <MaxRegistrationAmount
            settings={{ maxRegistrationAmount, lockedByAdmin, overrideChildSettings }}
            onUpdateSettings={updateSettings}
            hasSubscribedAccounts={hasSubscribedAccounts}
          />
          {hasSubscribedAccounts && (
            <div className='settingToggle'>
              <HelpText
                helpText={intl.formatMessage({ id: 'benchmarks.registrationPoints.description' })}
              />
              <FormControlLabel
                control={
                  <Switch
                    color='primary'
                    checked={overrideChildSettings?.lockRegistrationPoints?.enabled}
                    onChange={(e, isEnabled) => {
                      void updateSettings({
                        overrideChildSettings: {
                          ...overrideChildSettings,
                          lockRegistrationPoints: {
                            enabled: isEnabled
                          }
                        }
                      });
                    }}
                  />
                }
                label={intl.formatMessage({ id: 'settings.targets.lockRegistrationLabel' })}
              />
            </div>
          )}
          <HowToAccordion />
        </div>
        <div className={'table__wrapper'}>
          {hasRegistrationPointsLocked && (
            <Chip
              className={'tableChip'}
              variant='outlined'
              label={intl.formatMessage({ id: 'settings.targets.locked' })}
              icon={<LockIcon fontSize='small' />}
            />
          )}
          <AlteredMaterialTable
            nested
            title={intl.formatMessage({ id: 'settings.registrationPoints.tableHeader' })}
            tableRef={this.tableRef}
            // @ts-ignore
            columns={this.extractColumnsFromData()}
            data={registrationPoints}
            components={{
              Header: this.overrideTableHead,
              Body: this.overrideTableBody,
              Row: this.overrideTableRow,
              OverlayLoading: this.overrideOverlay,
              EditRow: this.overrideEditRow,
              Action: this.overrideAction
            }}
            onTreeExpandClick={this.onTreeExpandClick}
            actions={hasRegistrationPointsLocked ? undefined : this.customActions}
            options={{
              ...registrationPointTableOptions
            }}
            onRowClick={hasRegistrationPointsLocked ? undefined : this.onRowClick}
            editable={{
              onRowAdd: hasRegistrationPointsLocked ? undefined : this.onRowAdd,
              onRowUpdate: hasRegistrationPointsLocked ? undefined : this.onRowUpdate,
              onRowDelete: hasRegistrationPointsLocked ? undefined : this.onRowDelete
            }}
            style={{
              marginTop: '40px'
            }}
          />
          {hasRegistrationPointsLocked && <div className='table__overlay' />}
        </div>
        <div className={'table__wrapper'}>
          <LabelsContainer />
        </div>
        <ReasonsContainer />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  registrationPoints: getNonDeletedRegistrationPointsDepthFirst(state),
  registrationPointsMap: state.data.registrationPoints.registrationPointsMap,
  ingredientTableRefMap: state.data.registrationPoints.ingredientTableRefMap,
  currency: state.settings.currency,
  unit: state.settings.unit,
  allowRegistrationsOnAnyPoint: state.settings.allowRegistrationsOnAnyPoint,
  allowMultipleRegistrations: state.settings.allowMultipleRegistrations,
  allowReasonRegistrationsOnly: state.settings.allowReasonRegistrationsOnly,
  enableRegistrationReason: state.settings.enableRegistrationReason,
  enableRegistrationComments: state.settings.enableRegistrationComments,
  overrideChildSettings: state.settings.overrideChildSettings,
  hasRegistrationPointsLocked: state.settings.lockedByAdmin?.lockRegistrationPoints === true,
  hasLockedRegistrations: state.settings.lockedByAdmin?.enableLockedRegistrations,
  hasSubscribedAccounts: state.subAccounts.subscribed.length !== 0,
  reasons: state.reasons.reasons,
  enableLockedRegistrations: state.settings.enableLockedRegistrations,
  lockedByAdmin: state.settings.lockedByAdmin,
  enableAutomaticRegistrations: state.settings.enableAutomaticRegistrations,
  automaticRegistrationSchedule: state.settings.automaticRegistrationSchedule ?? [],
  maxRegistrationAmount: state.settings.maxRegistrationAmount,
  accountLabels: state.data.labels.labels,
  loadingLabels: state.data.labels.loading
});

const mapDispatchToProps = (dispatch) => ({
  getRegistrationPoints: () => dispatch(registrationPointsDispatch.findTree()),
  showModal: (data) => dispatch(uiDispatch.showModal(data)),
  closeModal: () => dispatch(uiDispatch.hideModal()),
  showNotification: (message, isError, icon) => {
    dispatch(showNotification(message, isError || false, icon ? icon : null));
  },
  createRegistrationPoint: (data) => dispatch(contentDispatch.createRegistrationPoint(data)),
  updateRegistrationPoint: (id, diff) =>
    dispatch(contentDispatch.updateRegistrationPoint(id, diff)),
  deleteRegistrationPoint: (id) => dispatch(contentDispatch.deleteRegistrationPoint(id)),
  createIngredient: (data: CreateIngredient) => dispatch(ingredientDispatch.createIngredient(data)),
  updateIngredient: (ingredientId: string, data: IPatchObject[]) =>
    dispatch(ingredientDispatch.updateIngredient(ingredientId, data)),
  deleteIngredient: (ingredientId: string) =>
    dispatch(ingredientDispatch.deleteIngredient(ingredientId)),
  updateSettings: (data) => dispatch(settingsDispatch.update(data)),
  getLabels: () => dispatch(labelsDispatch.getLabels()),
  createLabel: (data: { name: string }) => dispatch(labelsDispatch.createLabel(data))
});

export default withWidth()(
  connect<StoreProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(RegistrationSettings))
);
